import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AttributeViewerComponent } from './attribute-viewer.component';

@NgModule({
    declarations: [
        AttributeViewerComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        AttributeViewerComponent
    ]
})
export class AttributeViewerModule { }
